/* eslint-disable */
/* prettier-ignore */

export const TRANSLATIONS_PT = {
  "  Checked by (signature)": "  Verificado por (assinatura)",
  "! 3 of 4 types required:": "! 3 de 4 tipos obrigatórios:",
  "! Min. 14 characters": "! Mín. 14 caracteres",
  "! No name/username parts": "! Sem partes do nome/nome de utilizador",
  "! No spaces": "! Sem espaços",
  "/ occasion": "/ ocasião",
  "A new password should be different than the current one": "A nova palavra-passe deve ser diferente da atual",
  "ACCEPTED": "ACEITE",
  "Active flights": "Voos ativos",
  "Add deicing/anti-icing": "Adicionar degelo/anti-gelo",
  "Add description": "Adicionar descrição",
  "Add description if there is a irregularity!": "Adicione uma descrição se houver uma irregularidade!",
  "Add line": "Adicionar linha",
  "Add location where item was found": "Adicionar local onde o item foi encontrado",
  "Add note": "Adicionar nota",
  "add occasion": "adicionar ocasião",
  "Add other location": "Adicionar outra localização",
  "Add row": "Adicionar linha",
  "Add storage location": "Adicionar local de armazenamento",
  "Add your recovery email so we can send you a code if you ever forget your password.": "Adiciona teu e-mail de recuperação para te enviarmos um código caso esqueças tua senha.",
  "additional services": "serviços adicionais",
  "After clicking 'CONFIRM', the correction MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "Após clicar em 'CONFIRMAR', o MVT de correção será enviado. Pode ser reenviado se houver uma alteração em ALDT ou/ e AIBT.",
  "After clicking 'CONFIRM', the MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "Após clicar em 'CONFIRMAR', o MVT será enviado. Pode ser reenviado se houver uma alteração em ALDT ou/ e AIBT.",
  "Agent's name:": "Nome do agente:",
  "Agent's signature:": "Assinatura do agente:",
  "Aircraft Damage": "Danos em aeronaves",
  "Aircraft type": "Tipo de aeronave",
  "Airline": "Companhia aérea",
  "All": "Todos",
  "ALL": "TODOS",
  "All Airlines with Stocks": "Todas as companhias aéreas com stocks",
  "An error occurred while trying to verify your email address.": "Ocorreu um erro ao tentar verificar seu endereço de e-mail.",
  "and": "e",
  "and/or": "e/ou",
  "Anti-icing": "Anti-gelo",
  "Any email with @aviapartner.aero or @aviavip.com is not accepted!": "Qualquer e-mail com @aviapartner.aero ou @aviavip.com não é aceito!",
  "APPLY": "APLICAR",
  "approved": "aprovado",
  "Apr": "Abr",
  "Archived": "Arquivado",
  "Are you sure you want to change your password?": "Tem a certeza de que pretende alterar a palavra-passe?",
  "Are you sure you want to exit the current process?": "Tem a certeza de que pretende sair do processo atual?",
  "Are you sure you want to remove photo?": "Tem a certeza de que pretende remover a fotografia?",
  "Are you sure you want to sign out?": "Tem a certeza de que pretende terminar a sessão?",
  "area": "área",
  "Arrival MVT has been sent": "MVT de chegada foi enviado",
  "Arrival MVT not sent yet": "MVT de chegada ainda não enviado",
  "Arrival MVT sending": "MVT de chegada enviado",
  "Arrival MVT sent successfully": "MVT de chegada enviado com sucesso",
  "Attach photo": "Anexar foto",
  "Attachment": "Anexo",
  "Aug": "Ago",
  "Available": "Disponível",
  "Belt": "Cinto",
  "Body": "Corpo",
  "Briefly describe where the item will be stored for picking up.": "Descreva brevemente o local onde o artigo será armazenado para recolha.",
  "Call {{firstName}} {{lastName}}": "Ligar para {{firstName}} {{lastName}}",
  "Call sign": "Indicativo de chamada",
  "Cancel": "Cancelar",
  "CANCEL": "CANCELAR",
  "Cannot be after": "Não pode ser depois",
  "Cannot be before": "Não pode ser antes",
  "Cannot create MVT message: missing flight information": "Não é possível criar uma mensagem MVT: falta informação de voo",
  "Cannot send Arrival MVT": "Não é possível enviar o MVT de chegada",
  "Cannot send Arrival MVT. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Não é possível enviar o MVT de chegada. Os endereços (SITA e/ou e-mail) para este voo não estão configurados no Sunrise.",
  "Cannot send MVT ETD": "Não é possível enviar o MVT ETD",
  "Cannot send MVT ETD. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Não é possível enviar o MVT ETD. Os endereços (SITA e/ou e-mail) para este voo não estão configurados no Sunrise.",
  "Cannot set a future time.": "Não é possível definir uma hora futura.",
  "Change": "Alterar",
  "Change password": "Alterar a palavra-passe",
  "Change password?": "Alterar palavra-passe?",
  "Change your password:": "Alterar a palavra-passe:",
  "Checked by (signature)": "Verificado por (assinatura)",
  "Checks on easily visible parts of the aircraft from the ground": "Controlos das partes da aeronave facilmente visíveis do solo",
  "Checks on easily visible parts of the aircraft from the ground. No obvious damage or anomalies to:": "Verificações em partes facilmente visíveis da aeronave a partir do solo. Nenhum dano ou anomalias óbvias em:",
  "Chocks": "Calços",
  "Chute": "Chute",
  "CLEAR": "CLARA",
  "Client's signature:": "Assinatura do cliente:",
  "Clocked Time": "Hora registrada",
  "Close": "Fechar",
  "CLOSE": "FECHAR",
  "Close all my sessions on all devices": "Fechar todas as minhas sessões em todos os dispositivos",
  "Close registration": "Fechar o registo",
  "CLOSE REGISTRATION": "FECHAR REGISTO",
  "close the flight": "fechar o voo",
  "Closed": "Fechado",
  "Closing this window will discard all your recent changes.": "Fechar esta janela descartará todas as suas alterações recentes.",
  "Clouds": "Nuvens",
  "Comment": "Comentário",
  "Comment...": "Comentário...",
  "Comments": "Comentários",
  "Completed": "Concluída",
  "Conditional services": "Serviços condicionais",
  "Cones": "Cones",
  "CONFIRM": "CONFIRMAR",
  "Confirm": "Confirmar",
  "Confirm new password": "Confirmar a nova palavra-passe",
  "Confirm remove?": "Confirmar remoção?",
  "CONFIRMED": "CONFIRMADO",
  "Contact your administrator to request access": "Entre em contato com seu administrador para solicitar acesso",
  "Could not save data, please try again later": "Não foi possível guardar os dados, tente novamente mais tarde",
  "Crew signature": "Assinatura da tripulação",
  "Current password": "Palavra-passe atual",
  "Damage": "Danos",
  "Date range": "Intervalo de datas",
  "Date should not be before start date": "A data não deve ser anterior à data de início",
  "Day": "Dia",
  "Dec": "Dez",
  "DECLINED": "RECUSADO",
  "Default station": "Estação predefinida",
  "Deicing": "Descongelamento",
  "Deicing Service Registration": "Registo do serviço de degelo",
  "Delete Photo": "Apagar foto",
  "DENIED": "NEGADO",
  "Describe location": "Descrever a localização",
  "Dest.": "Dest.",
  "Destination": "Destino",
  "Did you forget something?": "Esqueceu alguma coisa?",
  "Don't use phone while driving!": "Não utilizar o telemóvel durante a condução!",
  "Dummy Type": "Tipo de manequim",
  "Edit Comment": "Editar comentário",
  "Emergency": "Emergência",
  "Emergency contacts are not set up": "Os contactos de emergência não estão configurados.",
  "employees": "funcionários",
  "End": "Fim",
  "End of anti-icing": "Fim da anti-congelante",
  "End Time": "Hora final",
  "End time should not be before start time": "A hora de fim não deve ser anterior à hora de início",
  "Entrance": "Entrada",
  "Error loading clocked times": "Erro ao carregar as horas registradas",
  "Error. The email doesn't meet standard formatting.": "Erro. O e-mail não atende à formatação padrão.",
  "exceeds the allowed limit for this flight": "excede o limite permitido para este voo",
  "Executor's name:": "Nome do executor:",
  "Executor's signature:": "Assinatura do executor:",
  "extra service": "serviço extra",
  "Extra services": "Serviços extra",
  "Extra shift request": "Pedido de turno suplementar",
  "Extra Shift Request": "Pedido de turno extra",
  "Extra shift request confirmed": "Pedido de turno extra confirmado",
  "failed": "reprovado",
  "Feb": "Fev",
  "Filter": "Filtro",
  "Filter group": "Filtrar grupo",
  "Filter group has not been updated": "O grupo de filtros não foi atualizado",
  "filter group not found": "grupo de filtros não encontrado",
  "finalization": "finalização",
  "Find the account recovery section and click \"Resend verification email\".": "Encontre a seção de recuperação de conta e clique em \"Reenviar e-mail de verificação\".",
  "FirebaseError: A document cannot be written because it exceeds the  maximum size allowed": "FirebaseError: Um documento não pode ser escrito porque excede o tamanho máximo permitido",
  "FirebaseError: A document cannot be written because it exceeds the maximum size allowed": "FirebaseError: Um documento não pode ser escrito porque excede o tamanho máximo permitido",
  "Flight": "Voo",
  "Flight details": "Detalhes do voo",
  "Flight information registration": "Registo de informações de voo",
  "Flight not found": "Voo não encontrado",
  "Flight number/registration": "Número de voo/registo",
  "Flight registration is closed": "O registo do voo foi encerrado",
  "Flight reopened": "Voo reaberto",
  "Flight type": "Tipo de voo",
  "Flights": "Voos",
  "Fluid name": "Nome do fluido",
  "Fluid name:": "Nome do fluido:",
  "Fluid type": "Tipo de fluido",
  "Forgot your password?": "Esqueceu-se da sua palavra-passe?",
  "Forms": "Formulários",
  "from": "de",
  "From": "De",
  "Full (Wings, stabilizer &, fuselage)": "Completo (Asas, estabilizador & fuselagem)",
  "Future time is not allowed": "A hora futura não é permitida",
  "Gate": "Porta de embarque",
  "General info": "Informações gerais",
  "Go to flights": "Ir para os voos",
  "Go to login": "Ir para o início de sessão",
  "Go to My Profile in your Sunrise account.": "Vá para Meu perfil na sua conta Sunrise.",
  "Go to Unread R&S": "Ir para R&S não lidas",
  "Helpdesk": "Serviço de assistência",
  "Hold Inspection on Arrival": "Suspender a inspeção à chegada",
  "Hold Inspection on Departure": "Aguardar inspeção à partida",
  "hr": "hr",
  "Humidity": "Humidade",
  "If damage is found, mark it on the sketch": "Se forem detectados danos, assinalá-los no desenho",
  "If the problem continues, go to My Profile to resend a new verification link.": "Se o problema continuar, vá para Meu perfil para reenviar um novo link de verificação.",
  "In order to close this flight you need to provide": "Para fechar este voo, é necessário fornecer",
  "In order to close this flight you need to provide mandatory details.": "Para fechar este voo, é necessário fornecer detalhes obrigatórios.",
  "In order to open 'Calendar', read and process recent Read & Sign messages.": "Para abrir o “Calendário”, ler e processar as mensagens recentes de leitura e assinatura.",
  "In order to send Arrival MVT you need to provide mandatory details": "Para enviar o MVT de Chegada é necessário fornecer os dados obrigatórios",
  "Include nearby area": "Incluir área próxima",
  "Included nearby area": "Área próxima incluída",
  "Incorrect code": "Código incorreto",
  "Input a brief description here": "Introduzir aqui uma breve descrição",
  "Inspected by": "Inspecionado por",
  "Inspection agent's signature": "Assinatura do agente de inspeção",
  "Inspection agent's signature:": "Assinatura do agente de inspeção:",
  "Inspections": "Inspecções",
  "Instructions": "Instruções",
  "Internal communication": "Comunicação interna",
  "Invalid ALDT/AIBT value or Arrival MVT with such ALDT and AIBT values already exist": "Valor ALDT/AIBT inválido ou já existe um MVT de chegada com esses valores ALDT e AIBT",
  "is logged in": "está registado",
  "Is Partial": "é parcial",
  "is signed in": "está conectado",
  "It's safe and encrypted - only used for password resets.": "É seguro e criptografado — usado apenas para redefinir a senha.",
  "Jan": "Jan",
  "Job vacancy": "Vaga de emprego",
  "Jul": "Jul",
  "Jun": "Jun",
  "KEY PEOPLE": "PESSOAS CHAVE",
  "Language": "Idioma",
  "Leave a comment about this timestamp and connected action.": "Deixe um comentário sobre este registo de data e hora e a ação ligada.",
  "Left Engine": "Motor esquerdo",
  "Left Tail Wing": "Asa da cauda esquerda",
  "Left Wing": "Asa esquerda",
  "Load Verification Cross-Check Form": "Formulário de controlo cruzado de verificação da carga",
  "Local (Under Wing / Local area contamination)": "Local (Sob a Asa / Contaminação da área local)",
  "Local Bags": "Bolsas Locais",
  "Locked application": "Aplicação bloqueada",
  "Log in": "Iniciar sessão",
  "Log out": "Terminar sessão",
  "Lost item": "Item perdido",
  "lowercase": "minúsculas",
  "Mar": "Mar",
  "Mark location": "Marcar o local",
  "May": "Mai",
  "Message archived": "Mensagem arquivada",
  "Message state": "Estado da mensagem",
  "Message type": "Tipo de mensagem",
  "Message unarchived": "Mensagem não arquivada",
  "Messages": "Mensagens",
  "messages yet": "mensagens ainda",
  "min": "min",
  "Mix": "Mistura",
  "Month": "Mês",
  "MVT History": "Histórico do MVT",
  "My profile": "O meu perfil",
  "Name Surname": "Nome Apelido",
  "Neck": "Pescoço",
  "New password": "Nova palavra-passe",
  "New password cannot be equal to current": "A nova palavra-passe não pode ser igual à atual.",
  "New password does not meet security requirements": "A nova palavra-passe não cumpre os requisitos de segurança",
  "next": "seguinte",
  "Next 5 days": "Próximos 5 dias",
  "No": "Não",
  "No active flights yet": "Ainda não há voos ativos",
  "No clocked times available": "Não há horas registradas disponíveis",
  "No content yet...": "Ainda sem conteúdo...",
  "No flight details information": "Nenhuma informação sobre os detalhes do voo",
  "No instructions found": "Não foram encontradas instruções",
  "No internet connection": "Não há ligação à Internet",
  "No key people assigned.": "Nenhuma pessoa-chave atribuída.",
  "No messages yet": "Ainda não há mensagens",
  "No photo available": "Nenhuma foto disponível",
  "No photos here yet": "Ainda não há fotos aqui",
  "No registration": "Sem registro",
  "No services available": "Não há serviços disponíveis",
  "No time logging found": "Nenhum registro de tempo encontrado",
  "No timestamps configured for this flight type": "Não há carimbos de hora configurados para este tipo de voo",
  "No types here yet": "Ainda não há tipos aqui",
  "no user data": "sem dados do utilizador",
  "None": "Nenhum",
  "Nose": "Nariz",
  "Not completed": "Não concluída",
  "Note": "Nota:",
  "Nov": "Nov",
  "NOW": "AGORA",
  "Number of unread R&S:": "Número de R&S não lidas:",
  "numbers": "números",
  "occasion": "ocasião",
  "Occasion": "Ocasião",
  "Oct": "Out",
  "Oops! It looks like your verification email didn't go through.": "Ops! Parece que o seu e-mail de verificação não foi enviado.",
  "Open": "Aberto",
  "Open a flight to add it to your active flights list.": "Abra um voo para adicioná-lo à sua lista de voos ativos.",
  "Open file": "Abrir ficheiro",
  "Open flight {{name}}": "Abrir voo {{name}}",
  "Operation flight number": "Número do voo da operação",
  "Operator's name": "Nome do operador",
  "Operator's name:": "Nome do operador:",
  "Operator's signature": "Assinatura do operador",
  "Operator's signature:": "Assinatura do operador:",
  "Optional": "Opcional",
  "or": "ou",
  "Origin": "Origem",
  "Other flights": "Outros voos",
  "Outside Air Temperature": "Temperatura do ar externo (C°)",
  "Outside Air Temperature (C°)": "Temperatura do Ar Externo (C°)",
  "Page not found": "Página não encontrada",
  "Parking": "Estacionamento",
  "Partially (Wings & stabilizer only)": "Parcialmente (Apenas asas & estabilizador)",
  "Password": "Palavra-passe",
  "Password must be at least 8 characters": "A palavra-passe tem de ter pelo menos 8 caracteres",
  "Password Not Unique. Your new password cannot be one of your last 5 used passwords.": "Palavra-passe não exclusiva. A sua nova palavra-passe não pode ser uma das suas últimas 5 palavras-passe utilizadas.",
  "Passwords do not match": "As palavras-passe não coincidem",
  "per occasion": "por ocasião",
  "Per pax": "Por passageiro",
  "per start": "por início",
  "percent": "porcentagem",
  "Photo registration": "Registo de fotografias",
  "Photo types required": "Tipos de fotos necessários",
  "Photo types required:": "Inspeção da rampa de segurança",
  "Photos": "Fotos",
  "Pick if its a damaged part or lost item": "Escolher se",
  "Pin on schema": "Pino no esquema",
  "Please briefly describe where you found the item": "Por favor, descreva brevemente onde encontrou o objeto",
  "Please click here to proceed to flights list": "Clique aqui para aceder à lista de voos",
  "Please make sure you attached photos of irregularities": "Certifica-te de que anexas fotografias das irregularidades",
  "Please pick on scheme": "Por favor, escolha um esquema",
  "Please reach out to your administrator for assistance": "Contacte o seu administrador para obter assistência.",
  "Please try sending it again later.": "Por favor, tente enviá-lo novamente mais tarde.",
  "Please try the link again.": "Por favor, tente o link novamente.",
  "Please, sign below": "Por favor, assine abaixo",
  "Post-deicing/anti-icing check completed": "Verificação pós-descongelamento/anti-congelante concluída",
  "Precipitation": "Precipitação",
  "Pressure": "Pressão",
  "Proceed to login": "Proceder ao login",
  "Product name": "Nome do produto",
  "Product type": "Tipo de produto",
  "Profile": "Perfil da estação",
  "Profile data wasn't updated!": "Os dados do perfil não foram actualizados!",
  "Psychosocial aid": "Apoio psicossocial",
  "Quantity (liter)": "Quantidade (litro)",
  "Read": "Ler",
  "Read & Sign": "Ler e assinar",
  "Read & Sign to do:": "Leia e assine para fazer:",
  "Read&Sign": "Ler e Assinar",
  "Receive Extra shift requests": "Receber pedidos de turnos extra",
  "Receive job vacancies": "Receber vagas de emprego",
  recovery: {
    "error1": "<1>Ops!</1> Parece que o seu e-mail de verificação não foi enviado.",
    "error2": "<1>Tente enviá-lo novamente mais tarde.</1>",
    "error3": "Pedimos desculpa pelo incómodo.",
    "inUse": "Este e-mail de recuperação já está <1>em uso!</1>",
    "success": "O <1>e-mail de verificação</1> foi enviado com sucesso!",
    validation: {
      "blockedDomainNote": "Qualquer e-mail com <1>@aviapartner.aero</1> ou <3>@aviavip.com</3> não é aceito!",
      "invalidFormat": "Erro. O e-mail não está no formato padrão."
    },
    "verified": "O seu e-mail de recuperação já está <1>verificado!</1>"
  },
  "Recovery email": "E-mail de recuperação",
  "Recovery email already verified!": "E-mail de recuperação já verificado!",
  "Recovery email verified!": "E-mail de recuperação verificado!",
  "Reg.": "Reg.",
  "Registration": "Registo",
  "Registration Closed": "Registo fechado",
  "REGISTRATION CLOSED": "REGISTO FECHADO",
  "registration complete": "registo completo",
  "Remark": "Observação",
  "Remove": "Remover",
  "Remove {{name}} from active flights": "Remover {{name}} dos voos ativos",
  "Reopen": "Reabrir",
  "reopen flight": "reabrir o voo",
  "Report any irregularities found upon arrival": "Comunicar qualquer irregularidade",
  "Report any other irregularities": "Comunicar quaisquer outras irregularidades",
  "Required": "Necessário",
  "required to close the flight": "necessário para fechar o voo",
  "Requirements of the password are not met.": "Os requisitos da palavra-passe não são cumpridos.",
  "Resend verification email": "Reenviar e-mail de verificação",
  "Right Engine": "Motor direito",
  "Right Tail Wing": "Asa da cauda direita",
  "Right Wing": "Asa direita",
  "Runway": "Pista de aterragem",
  "Safety Ramp Checklist": "Lista de verificação da rampa de segurança",
  "Safety Ramp Inspection": "Inspeção da Rampa de Segurança",
  "save": "guardar",
  "SAVE": "SALVAR",
  "Save service registrations problem": "Gravar problema de registo de serviços",
  "Screening": "Triagem",
  "Search": "Pesquisa",
  "Seat": "Lugar",
  "Seats": "Lugares",
  "Select type": "Selecionar tipo",
  "SEND ARRIVAL MVT": "ENVIAR MVT DE CHEGADA",
  "SEND CORRECTION ARRIVAL MVT": "ENVIAR MVT DE CHEGADA DE CORRECÇÃO",
  "Send the Arrival MVT message to recipients:": "Enviar a mensagem MVT de Chegada aos destinatários:",
  "SENT": "ENVIADO",
  "Sep": "Set",
  "Service info saved": "Informação de serviço guardada",
  "Service registration": "Registo do serviço",
  "Service registration is closed": "O registo de serviços está encerrado",
  "Service Type": "Tipo de Serviço",
  "Set": "Definir",
  "Set date": "Definir data",
  "Set time": "Definir hora",
  "Set time: End of anti-icing": "Definir hora: Fim da anti-congelante",
  "Set to now": "Definido para agora",
  "Short remark": "Comentário curto",
  "Show": "Mostrar",
  "Show Photo": "Mostrar foto",
  "Sign for understanding": "Assinar para compreensão",
  "Sign form below to complete it": "Assinar o formulário abaixo para o completar",
  "Sign in": "Iniciar sessão",
  "Sign out": "Sair",
  "Signed": "Assinado",
  "SKIP": "IGNORAR",
  "Skip this step": "Saltar este passo",
  "Something went wrong": "Algo correu mal",
  "Something went wrong. Please try again later.": "Ocorreu um erro. Tente novamente mais tarde.",
  "Something wrong": "Algo errado",
  "Sort.": "Ordenar",
  "Specify where did you found the item": "Especificar onde é que encontrou o artigo",
  "Start": "Hora de início",
  "Start anti-icing": "Iniciar anti-gelo",
  "Start Time": "Hora de início",
  "Station": "Estação",
  "Stations": "Estações",
  "Stop anti-icing": "Parar anti-gelo",
  "success": "sucesso",
  "Sunrise": "Nascer do sol",
  "Sunset": "Pôr do sol",
  "Switch flight": "Trocar voo",
  "symbols": "símbolos",
  "SYSTEM SETTINGS": "DEFINIÇÕES DO SISTEMA",
  "Tail": "Cauda",
  "Take a photo": "Tirar uma fotografia",
  "Take a photo of a finished action, this timestamp is dedicated to.": "Tire uma fotografia de uma ação finalizada, este registo de data e hora é dedicado a ela.",
  "Tap on area where damaged part is located": "Toque na área onde se encontra a peça danificada",
  "Task": "Tarefa",
  "Tasks & Flights": "Tarefas & Voos",
  "Telex messages": "Mensagens telex",
  "Temperature (C°)": "Temperatura (C°)",
  "The app has been updated": "A aplicação foi actualizada",
  "The APPI code is required when resetting your Aviapartner": "O código APPI é necessário quando reiniciar o seu Aviapartner",
  "The APPI code is required when resetting your Aviapartner account password in Sunrise or through the Aviapartner helpdesk. You can  always find your APPI code in your profile in Sunrise.": "O código APPI é necessário ao reiniciar a palavra-passe da sua conta Aviapartner no Sunrise ou através do serviço de assistência Aviapartner. Pode sempre encontrar o seu código APPI no seu perfil no Sunrise.",
  "the correction MVT will be sent": "o MVT de correção será enviado",
  "The current password you entered is incorrect.": "A palavra-passe atual introduzida está incorreta.",
  "The current password you've entered is incorrect": "A palavra-passe atual que introduziu está incorreta",
  "The elapsed time between": "O tempo decorrido entre",
  "The end time must be later than the start time.": "A hora de fim deve ser posterior à hora de início.",
  "the MVT will be sent": "o MVT será enviado",
  "The planning shown below might not be up-to-date": "O planeamento apresentado abaixo pode não estar atualizado",
  "The shift is already confirmed to": "A deslocação já está confirmada para os",
  "The username or password you've entered is incorrect": "O nome de utilizador ou a palavra-passe que introduziu está incorreto",
  "The username or password you've entered is incorrect. Please  double-check and try again.": "O nome de utilizador ou a palavra-passe que introduziu estão incorretos. Por favor, verifique novamente e tente novamente.",
  "The verification email has been sent successfully!": "O e-mail de verificação foi enviado com sucesso!",
  "This action is mandatory.": "Esta ação é obrigatória.",
  "This field is mandatory": "Este campo é obrigatório",
  "This form is signed": "Este formulário está assinado",
  "This message is marked as urgent": "Esta mensagem está marcada como urgente",
  "This recovery email is already in use!": "Este e-mail de recuperação já está em uso!",
  "This request is not valid anymore": "Este pedido já não é válido",
  "This section is used to deal with visible damage to the airplane": "Esta secção é utilizada para lidar com danos visíveis no avião",
  "This service has been registered for this flight over 80% of the time.": "Este serviço foi registrado para este voo mais de 80% das vezes.",
  "time": "tempo",
  "Time registration": "Registo de horas",
  "Timeline": "Linha de tempo",
  "Timestamp information": "Informação de timestamp",
  "Timestamps type": "Tipo de carimbo de data/hora",
  "to": "para",
  "To get a new one, simply follow these steps:": "Para obter um novo, basta seguir estas etapas:",
  "Today": "Hoje",
  "TODAY": "HOJE",
  "Tomorrow": "Amanhã",
  "Transfer Bags": "Bolsas de Transferência",
  "Truck Driver": "Motorista de caminhão",
  "Truck driver's signature": "Assinatura do motorista do caminhão",
  "Truck driver's signature:": "Assinatura do caminhoneiro:",
  "Truck Number": "Número do caminhão",
  "type": "tipo",
  "Type": "Tipo de produto",
  "Unavailable": "Indisponível",
  "Unread": "Não lido",
  "Until": "Até",
  "Unverified email": "E-mail não verificado!",
  "uppercase": "maiúsculas",
  "Username": "Nome de utilizador",
  "Username or email": "Nome de utilizador ou e-mail",
  "validating": "validação",
  "validation": "validação",
  "Verification Error": "Erro de Verificação",
  "Verification Link Expired": "Link de verificação expirado",
  "Verified email": "E-mail verificado",
  verify: {
    "alreadyVerifiedTitle": "E-mail de recuperação já verificado!",
    "error1": "Ocorreu um erro ao tentar verificar seu endereço de e-mail.",
    "error2": "Tente usar o link novamente.",
    "error3": "Se o problema persistir, vá para <1>Meu perfil</1> para reenviar um novo link de verificação.",
    "errorTitle": "Erro de verificação",
    "expiredStep1": "Vá para <1>Meu perfil</1> na sua conta Sunrise.",
    "expiredStep2": "Encontre a seção de recuperação de conta e clique em \"Reenviar e-mail de verificação\".",
    "expiredStepsIntro": "Para obter um novo, basta seguir estes passos:",
    "expiredTitle": "Link de verificação expirado",
    "successDescription": "Agora você pode usá-lo para recuperar o acesso à sua conta se esquecer sua senha.",
    "successTitle": "E-mail de recuperação verificado!",
    "verifying": "Verificando..."
  },
  "Verifying...": "Verificando...",
  "View key people": "Ver pessoas chave",
  "Visibility": "Visibilidade",
  "Visual checks must be performed AFTER GSE removal": "As verificações visuais devem ser efectuadas APÓS a remoção do GSE",
  "Visual checks must be performed BEFORE GSE positioning": "As verificações visuais devem ser efectuadas ANTES do posicionamento do GSE",
  "Walkaround Arrival Checklist": "Lista de controlo de chegada",
  "Walkaround Pre-Departure Checklist": "Lista de controlo antes da partida",
  "We apologize for the inconvenience.": "Pedimos desculpas pelo inconveniente.",
  "We strongly recommend saving it in your smartphone phonebook": "Recomendamos vivamente que o guarde na lista telefónica do seu smartphone",
  "We strongly recommend saving it in your smartphone phonebook so that you always have the APPI code at hand. To save the code, go to your Sunrise profile and scan the QR code with your smartphone.": "Recomendamos vivamente que o guarde na lista telefónica do seu smartphone para que tenha sempre o código APPI à mão. Para guardar o código, vá ao seu perfil Sunrise e digitalize o código QR com o seu smartphone.",
  "Weather": "Tempo",
  "Wind": "Vento",
  "Would you like to add it to your current registration?": "Gostaria de adicioná-lo ao seu registro atual?",
  "Write comment": "Escrever comentário",
  "write new comment": "escrever novo comentário",
  "Write your comment here, then press the green check mark": "Escreva aqui o seu comentário e, em seguida, prima a marca de verificação verde",
  "Year": "Ano",
  "Yes": "Sim",
  "Yesterday": "Ontem",
  "You are offline": "Está offline",
  "You can check your APPI code on Sunrise portal.": "Pode consultar o seu código APPI no portal Sunrise.",
  "You can now use it to regain access to your account if you forget your password.": "Agora você pode usá-lo para recuperar o acesso à sua conta se esquecer sua senha.",
  "You can't remove this temporal item": "Não é possível remover este item temporal",
  "You don't have permission to view clocked times": "Você não tem permissão para visualizar as horas registradas",
  "You don't have permissions to take a photo": "Não tem autorização para tirar uma fotografia",
  "You were signed out automatically": "Foi desconectado automaticamente",
  "Your password and confirmation password do not match": "A sua palavra-passe e a palavra-passe de confirmação não correspondem",
  "Your password has been changed successfully!": "A sua palavra-passe foi alterada com sucesso!",
  "Your password has expired. Please compose a new password and log in again.": "A sua palavra-passe expirou. Por favor, crie uma nova palavra-passe e inicie sessão novamente.",
  "Your password must contain at least eight characters": "A sua palavra-passe deve conter pelo menos oito caracteres",
  "Your password must contain at least eight characters, at least one number and both lower and uppercase letters.": "A sua palavra-passe deve conter pelo menos oito caracteres, pelo menos um número e letras maiúsculas e minúsculas.",
  "Your recovery email is already verified!": "O seu e-mail de recuperação já está verificado!",
  "Your session has expired. Please sign in again.": "A sua sessão expirou. Por favor, inicie sessão novamente."
};
